import React, { useState } from "react";
import { BsArrowRightSquareFill } from "react-icons/bs";
import StationsMaster from "./StationsInfo/StationsMaster";
const SMNavBar = () => {
  const [activePage, setActivePage] = useState("Station");

  return (
    <div className="">
      <div className="row">
        <div className=" mt-2 ms-5 border border-white rounded-pill  text-white card-header-soft col-md-2">
          <h5 className=" text-dark  rounded-pill">Station Mapping</h5>
        </div>
      </div>
      <h2 className="p-1"></h2>
      <div className="row">
        {/* <div className="">
          <div className=" d-flex justify-content-around border border-white rounded-pill p-2 text-white card-header-soft">
            <div>
              <h5 className="mt-2 text-dark">Station Mapping</h5>
            </div>
            <div className=" d-flex justify-content-center  ">
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setActivePage("Station");
                }}
                className={`border border-white Subject m-1 p-2 underline me-1 ${
                  activePage === "Station" && "activePage"
                }`}
              >
                Station
              </div>{" "}
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setActivePage("test");
                }}
                className={`border border-white Subject m-1 p-2 underline me-1 ${
                  activePage === "test" && "activePage"
                }`}
              >
                test
              </div>{" "}
            </div> */}
        {/* <div style={{ cursor: "pointer" }}>
              <button
                className="p-2 text-white "
                style={{
                  backgroundColor: "rgb(0, 11, 51)",
                  borderRadius: 40,
                  width: "125px",
                }}
              >
                Log In ➞
              </button>
            </div> */}{" "}
        {/* <div></div>
          </div>
        </div>{" "} */}
      </div>
      <div
        className=""
        style={{
          height: "90vh",
          overflowY: "auto",
        }}
      >
        {activePage === "Station" && <StationsMaster />}
      </div>
    </div>
  );
};
export default SMNavBar;
